export let LocalStorageKey

    ; (function (LocalStorageKey) {
        LocalStorageKey["User"] = "fss::user"
        LocalStorageKey["Token"] = "fss::token"
        LocalStorageKey["RefreshToken"] = "fss::refresh_token"
        LocalStorageKey["BaseUrl"] = "fss::base_url"
        LocalStorageKey["Language"] = "fss:language"
    })(LocalStorageKey || (LocalStorageKey = {}))

function getItem(key) {
    const item = window.localStorage.getItem(key.toString())
    return item ? JSON.parse(item) : item
}

function setItem(key, value) {
    return window.localStorage.setItem(key.toString(), JSON.stringify(value))
}

function removeItem(key) {
    return window.localStorage.removeItem(key.toString())
}

export const LocalStorageHelper = { getItem, setItem, removeItem }
